<template>
  <div class="row">
    <div class="pie">
      <chart
        ref="carModelSaleTotalPie"
        :height="300"
        :option="carModelSaleTotalPieOption()"
      />
    </div>
    <div class="line">
      <chart
        ref="carModelSaleTotalLine"
        :height="300"
        :option="carModelSaleTotalLineOption()"
      />
    </div>
  </div>
</template>
<script>
import Chart from "@/components/chart";
// （柱状 | 折现）图
function getBarOrLineChartOption(config = {}) {
  return {
    title: {
      text: config.title,
      top: 10,
      left: 50,
      textStyle: {
        fontSize: 16
      }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    legend: {
      show: config.legend,
      data: config.legend,
      bottom: 5
    },
    grid: config.grid,
    xAxis: {
      type: config.xAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.xAxis
    },
    yAxis: {
      type: config.yAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.yAxis
    },
    series: config.series
  };
}

// 饼图
function getPieChartOption(config = {}, seriesData = []) {
  return {
    title: {
      text: config.title,
      top: 10,
      left: 50,
      textStyle: {
        fontSize: 16
      }
    },
    // 悬浮提示
    tooltip: {
      appendToBody: true,
      trigger: "item"
    },
    // 中间文本
    graphic: {
      type: "text",
      left: "center",
      top: "center",
      style: {
        text: config.total, // 显示文本
        textAlign: "center",
        fill: "#000",
        fontSize: 20
      }
    },
    // 图例
    legend: {
      show: config.legendShow,
      orient: "vertical", // 竖向展示
      left: "right", // 整体靠右
      icon: "circle", // 图标样式
      align: "left", // 图标在左
      itemGap: 3, // 间距
      top: "center" // 垂直居中
    },
    series: [
      {
        type: "pie",
        radius: config.radius, // 饼图占比
        itemStyle: {
          normal: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 1,
            color: function(params) {
              // 定制颜色，params.dataIndex 为当前数据项的索引
              var colorList = config.colorList;
              return colorList[params.dataIndex];
            }
          }
        },
        label: {
          show: config.labelShow,
          formatter: config.formatter || "{b}\n{c}" // 标签格式
        },
        data: seriesData
      }
    ]
  };
}

export default {
  name: "carModelSaleTotal",
  components: {
    Chart
  },
  data() {
    return {
      carModelSaleTotalStatis: {
        saleCarTypeRing: [],
        saleCarTypeLine: []
      },
      competeBrandList: []
    };
  },
  methods: {
    // 获取统计数据
    getStatisData(saleCarTypeTotal = {}) {
      this.carModelSaleTotalStatis.saleCarTypeRing =
        saleCarTypeTotal.saleCarTypeRing || [];
      this.carModelSaleTotalStatis.saleCarTypeLine =
        saleCarTypeTotal.saleCarTypeLine || [];
    },
    // 车辆类型销售总量饼图
    carModelSaleTotalPieOption() {
      const config = {
        labelShow: true,
        title: "车辆类型销售总量",
        radius: ["60%", "45%"],
        colorList: ["#5087EC", "#68bbc4", "#58a55c", "#f2bd42"],
        formatter: "{b}\n{c}辆" // 标签格式
      };
      const seriesData = this.carModelSaleTotalStatis.saleCarTypeRing;
      return getPieChartOption(config, seriesData);
    },
    // 车辆类型销售总量折线图
    carModelSaleTotalLineOption() {
      const config = {
        legend: this.carModelSaleTotalStatis.saleCarTypeLine,
        grid: { bottom: 60, top: 60, left: 120, right: 120 },
        xAxisType: "category",
        yAxisType: "value",
        xAxis: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        series: [
          {
            name: "SUV",
            type: "line",
            color: "#5087EC",
            data:
              this.carModelSaleTotalStatis.saleCarTypeLine.find(
                item => item.name === "SUV"
              )?.data || [],
            label: {
              show: true,
              position: "top"
            }
          },
          {
            name: "微卡",
            type: "line",
            color: "#68bbc4",
            data:
              this.carModelSaleTotalStatis.saleCarTypeLine.find(
                item => item.name === "微卡"
              )?.data || [],
            label: {
              show: true,
              position: "top"
            }
          },
          {
            name: "微面",
            type: "line",
            color: "#58a55c",
            data:
              this.carModelSaleTotalStatis.saleCarTypeLine.find(
                item => item.name === "微面"
              )?.data || [],
            label: {
              show: true,
              position: "top"
            }
          },
          {
            name: "其他",
            type: "line",
            color: "#f2bd42",
            data:
              this.carModelSaleTotalStatis.saleCarTypeLine.find(
                item => item.name === "其他"
              )?.data || [],
            label: {
              show: true,
              position: "top"
            }
          }
        ]
      };
      return getBarOrLineChartOption(config);
    }
  }
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  .pie {
    width: 30%;
  }
  .line {
    width: 70%;
  }
}
</style>
